<template>
	<div id="balance-banner" class="col-12 px-0">
		<div class="container">
      <div class="d-flex align-items-center">
        <p class="px-2 py-2 my-1 mb-0 w-100">
          You have <b>£{{ parseFloat(account_balance).toFixed(2) }}</b> in your
          account{{ text }}
          <b v-if="nextOrderRecurrable">£{{ nextOrderCost }}</b>
        </p>
        <img
          src="/assets/icons/account/close-icon.svg"
          height="20"
          width="20"
          alt="close balance banner icon"
          @click="closeBanner"
        />
      </div>
    </div>
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { useAuthUser } from '../../../utils/stores/modules/authUser'

const userStore = useAuthUser()
// Props (defineProps)
// Emits (defineEmits)
const emit = defineEmits(['close-balance-banner'])
// Reactive variables (inc composables)
// Computed
const account_balance = computed(() => userStore.accountBalance)
const nextOrderRecurrable = computed(() => userStore.getNextOrderRecurrable)
const text = computed(() => nextOrderRecurrable.value ? ', and your next order will cost ' : '')
const nextOrderCost = computed(() => {
  if (!nextOrderRecurrable.value?.total) return 0
  const diff = Math.abs(account_balance.value - nextOrderRecurrable.value.total)
  return account_balance.value <= nextOrderRecurrable.value.total
    ? parseFloat(diff).toFixed(2)
    : 0
})
// Methods
function closeBanner() {
  emit('close-balance-banner', false)
}
// Lifecycle Hooks
// Expose (defineExpose)
</script>
<script>
export default {
	name: 'BalanceBanner',
}
</script>
<style lang="scss">
#balance-banner {
  background-color: #D6F2ED;

	span {
		font-size: 20px !important;
    line-height: 22px;
	}

  p{
    color: #1D4045;
    text-align: center;
    /* MD-L */
    font-family: 'Apercu';
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 22px; /* 137.5% */
  }

  img {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    aspect-ratio: 1/1;
  }
}
</style>
